// ToastListener.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";

/**
 * Automatically dismisses all toasts on route change.
 */
const ToastListener = () => {
  const location = useLocation();

  useEffect(() => {
    toast.dismiss(); // Clear all toasts on URL change
  }, [location.pathname]);

  return null; // No UI
};

export default ToastListener;
